import client from './AxiosClient'

const contactusService = {
    get : (params) => client.get("/contact-us", { params }),
    put : (data) => client.put("/contact-us", data ),


}

export default contactusService;